import React, { useState, useEffect } from 'react';
import styles from '../../../styles/ManageAgency.module.css';
import buttonStyles from '../../../styles/Buttons.module.css';

interface User {
  _id: string;
  displayName: string;
  email: string;
}

interface RemoveUserFormProps {
  users: User[];
  onRemove: (userIds: string[]) => void;
  onCancel: () => void;
}

const RemoveUserForm: React.FC<RemoveUserFormProps> = ({ users, onRemove, onCancel }) => {
  const [selected, setSelected] = useState<string[]>([]);

  // Clear selection if users list changes (e.g., after removal)
  useEffect(() => {
    setSelected([]);
  }, [users]);

  const handleSelect = (userId: string) => {
    setSelected(prev =>
      prev.includes(userId)
        ? prev.filter(id => id !== userId)
        : [...prev, userId]
    );
  };

  const handleRemove = () => {
    if (selected.length > 0) {
      onRemove(selected);
    }
  };

  return (
    <div>
      <table className="w-full border-collapse mb-16">
        <thead>
          <tr>
            <th className="text-left p-8">Select</th>
            <th className="text-left p-8">Name</th>
            <th className="text-left p-8">Email</th>
          </tr>
        </thead>
        <tbody>
          {users.map(user => (
            <tr key={user._id} className="border-b">
              <td className="p-8">
                <input
                  type="checkbox"
                  checked={selected.includes(user._id)}
                  onChange={() => handleSelect(user._id)}
                />
              </td>
              <td className="p-8 break-words">{user.displayName}</td>
              <td className="p-8 break-words">{user.email}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className={styles.removeActions}>
        <button
          onClick={handleRemove}
          disabled={selected.length === 0}
          className={buttonStyles.removeButton}
        >
          Remove
        </button>
        <button
          type="button"
          onClick={onCancel}
          className={buttonStyles.removeButton}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default RemoveUserForm;
